<h2 mat-dialog-title>{{ 'permit.config.statuses.migrate_title' | translate }}</h2>
<mat-dialog-content>
    <p class="migrate-body">{{ 'permit.config.statuses.migrate_body' | translate }}</p>
    <div class="field-group">
        <label class="field-label">{{ 'permit.config.statuses.migrate_target' | translate }}</label>
        <select class="field-input" [(ngModel)]="targetId">
            <option [ngValue]="null" disabled></option>
            <option *ngFor="let target of data.targets" [ngValue]="target._id">
                {{ statusName(target) }}
            </option>
        </select>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">{{ 'permit.config.common.cancel' | translate }}</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!targetId" (click)="confirm()">
        {{ 'permit.config.statuses.migrate_confirm' | translate }}
    </button>
</mat-dialog-actions>
